import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import './AccountFeatures.css';

const AccountFeatures = ({ title = 'Account Features', items }) => {
  if (!items?.length) {
    return null;
  }

  return (
    <section className="wealth-account-features">
      <div className="wealth-account-features__inner">
        <div className="wealth-account-features__panel">
          <Reveal>
            <h2 className="wealth-account-features__title">{title}</h2>
            <dl className="wealth-account-features__list">
              {items.map(({ label, value }) => (
                <div key={label} className="wealth-account-features__row">
                  <dt className="wealth-account-features__label">{label}</dt>
                  <dd className="wealth-account-features__value">{value}</dd>
                </div>
              ))}
            </dl>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default AccountFeatures;
